import { FILTERS_SET_SHOW_FILTERS_MODAL } from '../../constants/actionTypes';
import { TReduxActions } from '../../types/redux';

const defaultDealType = false;

export function showFiltersModalReducer(state: boolean | undefined = defaultDealType, action: TReduxActions) {
  switch (action.type) {
    case FILTERS_SET_SHOW_FILTERS_MODAL:
      return action.showFiltersModal;
  }

  return state;
}
